import script from "./MainBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MainBanner.vue?vue&type=script&setup=true&lang=js"

import "./MainBanner.vue?vue&type=style&index=0&id=3851b9c8&scoped=true&lang=css"

import exportComponent from "/home/hans/Proyectos/Clever/AlicaMedios/alicamedios.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3851b9c8"]])

export default __exports__